import { render, staticRenderFns } from "./MyRobot.vue?vue&type=template&id=27f197f7&"
import script from "./MyRobot.vue?vue&type=script&lang=js&"
export * from "./MyRobot.vue?vue&type=script&lang=js&"
import style0 from "./MyRobot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports